var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.form.loggedInOnly || (_vm.form.loggedInOnly && _vm.loggedUser))?_c('form-content',{staticClass:"content form_content",attrs:{"id":_vm.value},on:{"send":_vm.onSend}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }